// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import Edit from "@insite/mobius/Icons/Edit";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import { linkLikeButtonCss } from "@sc/App/SharedStyles/MyAccountDetailsStyles";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import Print from "@sc/XDL/Icons/Print";
import { generateButtonLinkStyle, mergeWithCss } from "@sc/XDL/Utilities";

orderApprovalDetailsActionButtonsStyles.printButton = {
    ...mergeWithCss(generateButtonLinkStyle(Print), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    ...mergeWithCss(generateButtonLinkStyle(ArrowRight), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.deleteButton = {
    ...mergeWithCss(generateButtonLinkStyle(Trash2), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.approveButton = {
    ...mergeWithCss(generateButtonLinkStyle(Save), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.showActivityLogButton = {
    ...mergeWithCss(generateButtonLinkStyle(""), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.requestRevisionButton = {
    ...mergeWithCss(generateButtonLinkStyle(""), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.editButton = {
    ...mergeWithCss(generateButtonLinkStyle(Edit), linkLikeButtonCss),
};
